import { render, staticRenderFns } from "./FullPageLayout.vue?vue&type=template&id=4e64935e&scoped=true&"
import script from "./FullPageLayout.vue?vue&type=script&lang=ts&"
export * from "./FullPageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e64935e",
  null
  
)

export default component.exports